<template>
  <div class="userContent">
    <span class="header-customerName"></span>
    <template>
      <div v-if="accountList.length <= 1" class="companyBox header-avatar" style="cursor: pointer">
        <span v-if="customerName" class="name">
          <img v-if="isEnterprise" :src="qiyeIcon" class="customer_icon">
          <img v-else :src="kehuIcon" class="customer_icon">
          {{customerName}}({{ relativeCode }})
        </span>
      </div>
      <a-popover v-else v-model="visible" :get-popup-container="setContainer" class="companyBox" trigger="click" @visibleChange="visibleChange">
        <div class="header-avatar" style="cursor: pointer">
        <span class="name">
          <img v-if="isEnterprise" :src="qiyeIcon" class="customer_icon">
          <img v-else :src="kehuIcon" class="customer_icon">
          {{customerName}}({{ relativeCode }})
          <a-icon class="iconStyle" type="down" />
        </span>
        </div>
        <div slot="content" class="company" @click.stop="">
          <div class="inputBox">
            <a-input v-model="companyName" placeholder="请输入" autocomplete="off" @change="onChange" >
              <img  slot="prefix" :src="SearchIcon" class="search_icon">
            </a-input>
          </div>
          <userSelect :user-data="list" @change="onSelect" @changeVisible="changeVisible"></userSelect>
          <!-- <div v-for="(company, i) in list" :key="i" class="companyItem select_item" @click="onSelect(company,company.name||company.corpName)">
            <img :src="customerTypeIcon[company.corpCustomer]" class="customer_icon">
            <span>{{company.name||company.corpName}}</span>
          </div> -->
        </div>
      </a-popover>
    </template>
    <a-popover v-if="!isHiddenMenu" class="companyBox" trigger="click" :get-popup-container="setContainer" @visibleChange="visibleChange">
      <div class="header-avatar" style="cursor: pointer">
        <div>
          <img src="@/assets/img/icon_head.png" class="icon-head" alt="">
        </div>
        <span class="name">
          {{realName}}
          <a-icon class="iconStyle" type="down" />
        </span>
      </div>
      <div slot="content" class="avatar-menu" @click.stop="">
        <div class="companyItem" @click="goToModifyAccount">
          <img src="@/assets/img/auth/icon_edit.png" alt="">
          <span>修改账号</span>
        </div>
        <div class="companyItem" @click="goToModifyPassword">
          <img src="@/assets/img/auth/icon_password.png" alt="">
          <span>修改密码</span>
        </div>
        <div class="companyItem" @click="logout">
          <img src="@/assets/img/auth/icon_close.png" alt="">
          <span>退出登录</span>
        </div>
      </div>
    </a-popover>
    <!-- <a-dropdown :trigger="['click']">
      <div class="header-avatar" style="cursor: pointer">
        <span class="name">
          {{realName}}
          <a-icon class="iconStyle" type="down" />
        </span>
        <img v-if="!this.$store.state.user.customerId" class="noAuth" src="@/assets/img/auth/lable_grey.png" alt="">
      </div>
      <a-menu slot="overlay" :class="['avatar-menu']">
        <a-menu-item @click="goToModifyAccount">
          <img src="@/assets/img/auth/icon_edit.png" alt="">
          <span>修改账号</span>
        </a-menu-item>
        <a-menu-item @click="goToModifyPassword">
          <img src="@/assets/img/auth/icon_password.png" alt="">
          <span>修改密码</span>
        </a-menu-item>
        <a-menu-item @click="logout">
          <img src="@/assets/img/auth/icon_close.png" alt="">
          <span>退出登录</span>
        </a-menu-item>
      </a-menu>
    </a-dropdown> -->
    <span class="task">
      <span @click="toTask">任务</span>
      <a-popover
        v-model="popover"
        class="taskPopo"
        :mouse-leave-delay="200"
        overlay-class-name="popoStyle"
        placement="bottomRight"
      >
        <template slot="content">
          <p class="title">提交成功</p>
          <p>请等待几分钟后前往<span class="taskLink" @click="toTask">任务</span>跟踪导入结果</p>
          <p class="btnBox">
            <a-button type="primary" @click="closePopo">知道了</a-button>
          </p>
        </template>
      </a-popover>
    </span>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { logout } from "@/services/user";
import { EventBus } from '@/utils/event-bus'

import userSelect from '@/components/userSelect/userSelect.vue'
import qiyeIcon from '@/assets/img/auth/icon_qi_circle.png'
import kehuIcon from '@/assets/img/auth/icon_ke_circle.png'
import SearchIcon from '@/assets/img/auth/icon_search.png'

export default {
  name: "HeaderAvatar",
  components:{
    userSelect
  },
  props: {
    accountList: {
      type: Array,
      default: () => []
    },
    orgNameAccountList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      customerName: "",
      relativeCode:"",
      kehuIcon,
      qiyeIcon,
      SearchIcon,
      contacts: "",
      popover: false,
      companyName: '',
      visible: false,
      companyList: [],
      list: [],
      isEnterprise:false,
    };
  },
  computed: {
    userName() {
      return this.$store.state.user.userName;
    },
    realName() {
      return this.$store.state.user.realName
    },
    ...mapGetters('iframe', ['isHiddenMenu']),
  },
  watch:{
    orgNameAccountList(value){
      this.list = value
    },
  },
  created() {
    this.list = this.orgNameAccountList
    const {accountName,creditCode,customerCode}=this.$store.state.user
    this.customerName = accountName
    this.relativeCode=creditCode||customerCode
    this.isEnterprise=!!creditCode
  },
  mounted() {
    EventBus.$on("taskPopover", () => {
      this.popover = true;
      setTimeout(() => {
        this.closePopo()
      }, 8000)
    });
  },
  beforeDestroy(){
    EventBus.$off('taskPopover')
  },
  methods: {
    goToModifyAuth(){
      this.$router.push('/authentication')
    },
    visibleChange(visible){
      if(!visible){
        this.companyName = ''
      } else {
        this.$emit('onSearch', '')
      }
    },
    changeVisible() {
      this.visible = false;
      this.companyName = ''
    },
    onChange(){
      this.$emit('onSearch', this.companyName)
      EventBus.$emit('onSearch', this.companyName)
    },
    logout() {
      logout();
      this.$router.push("/login");
    },
    goToModifyPassword() {
      this.$router.push("/modifyPassword");
    },
    goToModifyAccount() {
      this.$router.push("/modifyAccount");
    },
    toTask() {
      const {customerId,creditCode}=this.$store.state.user
      if(!customerId&&!creditCode){
        this.$message.warning('请先实名认证')
        return
      }
      this.$router.push('/task')
    },
    closePopo() {
      this.popover = false
    },
    onSelect(company,name) {
      sessionStorage.removeItem('getCreditTips')
      sessionStorage.removeItem('showCreditTips')
      sessionStorage.removeItem('creditPercentage')
        this.isEnterprise=!!company.corpCustomer
      this.visible = false
      this.customerName = name;
      localStorage.setItem('customerName', name)
      this.$emit('onChange',company)
      this.companyName = ''
    },
    setContainer(){
      return document.body
    }
  }
};
</script>

<style lang="less">
.userContent {
  .companyBox{
    z-index: 100;
    margin-right: 30px;
    align-items: center;
    .icon-head {
      width: 40px;
      height: 40px;
      margin-right: 8px;
    }
  }
}
.company{
  width: 368px;
  background: #fff;
  min-height: 100px;
  padding-top: 40px;
  max-height: 311px;
  overflow-y: scroll;
  .inputBox{
    width: calc(100% - 32px);
    position: absolute;
    top: 22px;
    left: 16px;
    z-index: 222;
  }
  .companyItem{
    text-align: left;
    padding: 5px 12px;
    &:hover{
      background: #F2FBF8;
    }
  }
}
.header-avatar {
  display: inline-flex;
  .avatar,
  .name {
    align-self: center;
  }
  .avatar {
    margin-right: 8px;
  }
  .name {
    font-weight: 500;
  }
}
.avatar-menu {
  width: 154px;
  .companyItem{
    height: 32px;
    line-height: 32px;
    padding: 0 12px;
    &:hover{
      cursor: pointer;
      background-color: #F2FBF8;
    }
  }
  img{
    margin-right: 6px;
    width: 16px;
    height: 16px;
  }
}
.task {
  margin-left: 20px;
  position: relative;
  text-decoration: underline;
  .taskPopo {
    position: absolute;
    top: 100%;
  }
}
.popoStyle {
   .ant-popover-inner-content {
    background: #363a3a !important;
    color: #fff;
    border-radius: 5px;
    .taskLink{
      color: #06b880;
      text-decoration: underline;
      text-decoration-color: #06b880;
      &:hover{
        cursor: pointer;
      }
    }
    .title{
      font-weight: bold;
    }
    .btnBox{
      text-align: center;
      margin-top: 20px;
    }
  }
  .ant-popover-arrow {
    background: #3f4154 !important;
    border-color: #3f4154 !important;
  }
}
.iconStyle{
  font-size: 10px;
}
.noAuth{
  width: 61px;
  height: 22px;
  margin-top: 20px;
  margin-left: 10px;
}
::v-deep .ant-popover-inner-content {
    padding: 0 !important;
 }
 .customer_icon {
      height: 24px;
      width: 24px;
      margin-right: 4px;
    }
    .search_icon {
      width: 24px;
      height: 24px;
    }

</style>
<style lang="less" scoped>
.inputBox {
 /deep/.ant-input-affix-wrapper {
    .ant-input-prefix {
        left: 4px !important;
      }
  }
}
</style>
